import type { PropertiesTableItemWithTooltip } from './PropertiesTable.types'

/** The parts of a table row the highlight reads; a grouped row's leaves are the property rows under it. */
type HighlightableRow = {
  original: unknown
  getIsGrouped: () => boolean
  getLeafRows: () => { original: unknown }[]
}

type RowHighlight = 'highlighted' | 'containsHighlighted' | null

/**
 * A property row is highlighted when the callback says so; a group row shows that one of its
 * properties is, so the selection can be found while the group is collapsed.
 */
export function getRowHighlight(
  row: HighlightableRow,
  isRowHighlighted: ((item: PropertiesTableItemWithTooltip) => boolean) | undefined
): RowHighlight {
  if (!isRowHighlighted) {
    return null
  }
  const isHighlightedItem = (item: unknown): boolean => isRowHighlighted(item as PropertiesTableItemWithTooltip)
  if (row.getIsGrouped()) {
    return row.getLeafRows().some((leaf) => isHighlightedItem(leaf.original)) ? 'containsHighlighted' : null
  }
  return isHighlightedItem(row.original) ? 'highlighted' : null
}
